import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";

const FourthTrimesterLandingPage = () => {
  const userInfo = useSelector((state) => state.userData);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleNext = () => {
      navigate("/edit-healthprofilesetup");
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

    return (
      <>
      <div className="registration-block-main">
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="registration-form-main">
          <div className="registration-form">
            <h2 className="page-heading-secondary-black mb-4">Welcome back, {userInfo.userData.FirstName}!</h2>
            <p>We’re glad you’re here! Has your family journey changed since your last visit? Your current app settings indicate you’re navigating a {userInfo?.userData?.WhyHere?.replace(/^I want /, "") || "N/A"} journey. If that’s changed, please update your profile to ensure we're providing the most relevant support. 
            </p>
            <div className="mb-3 d-flex">
                    <button type="submit" className="win-btn-primary mt-4" onClick={handleNext}>{t('editProfile')}</button>
                </div>
          </div>
          
        </div>
      </div>
    </>
    );
  };
  export default FourthTrimesterLandingPage;